// extracted by mini-css-extract-plugin
export default {"item":"Item_item__v4+TL","avatar":"Item_avatar__s5e-X","man":"Item_man__SrkcD","position":"Item_position__gVnK4"};